'use es6';
/*
 * Requires:
 *   react-codemirror/static-1.5611/sass/panel.sass
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CodeMirror from 'codemirror';
import Position from 'react-codemirror/enum/Position';
const CLASS_NAME = 'CodeMirror-hs-panel';
const POSITION_CLASS = {
  [Position.BOTTOM]: 'CodeMirror-hs-panel-bottom',
  [Position.TOP]: 'CodeMirror-hs-panel-top'
};
export default class Panel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      className: this.getClassName()
    };
    this.onOptionChange = this.onOptionChange.bind(this);
  }

  componentDidMount() {
    this.props.codemirror.on('optionChange', this.onOptionChange);
  }

  componentWillUnmount() {
    if (this.props.codemirror) {
      this.props.codemirror.off('optionChange', this.onOptionChange);
    }
  }

  onOptionChange(cm, option) {
    if (option === 'theme') {
      this.setState({
        className: this.getClassName()
      });
    }
  }

  getClassName() {
    const positionClass = POSITION_CLASS[this.props.position];
    const baseClassName = classNames(CLASS_NAME, positionClass, this.props.className);
    const theme = this.props.codemirror.getOption('theme');

    if (!theme) {
      return baseClassName;
    }

    const themes = theme.trim().split(/\s+/);
    const themeClasses = themes.map(th => `cm-s-${th}`);
    return [baseClassName].concat(themeClasses).join(' ');
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: this.state.className,
      children: this.props.children
    });
  }

}
Panel.propTypes = {
  codemirror: PropTypes.instanceOf(CodeMirror).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  position: PropTypes.oneOf([Position.BOTTOM, Position.TOP])
};
Panel.defaultProps = {
  position: Position.BOTTOM
};